import React, { useState, Fragment } from 'react';
import styles from './top-20-univ.module.scss';
import { dataConvertOverview } from '../../utils/overall-convert';
import { top20Overview } from "../../data/data-top20-univ";
// import { univTotalData } from '../../data/data-top20-univ';
import { formatNumberWithDot } from '../../utils/utils';
import CountryFlag from '../common/countryFlag/country-flag';
// import ProgressBar from '../common/progressBar/progress-bar.module';
import SelectDropdown from '../common/selectDropdown/select-dropdown';
import IconSort from '../common/icon/icon-sort';
import ReverseIconSort from '../common/icon/reverse-icon-sort';

const options = [
  { label: "% of world's centi-millionaires", value: "centiGrowth" },
  { label: "Centi-millionaires", value: "centiMillionaires" },

];

const Top20Univ = () => {

  const [sortColumn, setSortColumn] = useState("centiGrowth");
  // const [display, setDisplay] = useState();
  const [countryCount, setCountryCount] = useState(1);
  const [centiMilCount, setCentiMilCount] = useState(1);
  const [centiGrowthCount, setCentiGrowthCount] = useState(1);

  const dataTop20UnivOverview = () => {
    return dataConvertOverview(top20Overview);
  }

  const handleOptionSelect = (option) => {
    // setSelectedOption(option);
    setSortColumn(option.value);
    // setDisplay(-1);
  };

  const handleSort = (columnName) => {
    switch (columnName) {
      case 'country':
        (countryCount === 1) ? setCountryCount(-1) : setCountryCount(1);
        break;
      case 'centiMillionaires':
        (centiMilCount === 1) ? setCentiMilCount(-1) : setCentiMilCount(1);
        break;
      case 'centiGrowth':
        (centiGrowthCount === 1) ? setCentiGrowthCount(-1) : setCentiGrowthCount(1);
        break;
      default:
        break;
    }

    setSortColumn(columnName);
    // setDisplay(-1);
  };

  const reverseSortNum = (columnName, count) => {
    if (count === 1) {
      return dataTop20UnivOverview().sort((a, b) => b[columnName] - a[columnName]);
    }
    return dataTop20UnivOverview().sort((a, b) => a[columnName] - b[columnName]);
  }

  const handleSortingOptions = (columnName) => {
    switch (columnName) {
      case 'country':
        return (countryCount === 1) ?
          dataTop20UnivOverview().sort((a, b) => b[columnName].localeCompare(a[columnName]))
          : dataTop20UnivOverview().sort((a, b) => a[columnName].localeCompare(b[columnName]));
      case 'centiMillionaires':
        return reverseSortNum(columnName, centiMilCount);
      case 'centiGrowth':
        return reverseSortNum(columnName, centiGrowthCount);
      default:
        break;
    }

  }

  const sortedData = sortColumn
    ? handleSortingOptions(sortColumn)
    : dataTop20UnivOverview();


  // const handleMobileRowClick = (index) => {
  //   setDisplay(index);
  // }


  return (
    <>
      <h3 className="mb-5">Top 20 Universities for Centi-Millionaires</h3>
      {/* <h3 className="mb-5">Which universities produce the most centi-millionaires?</h3> */}
      <div className={`d-md-none ${styles.sortMobileWrapper}`}>
        <div className={styles.sortTitle}>Sort by</div>
        <SelectDropdown options={options} onSelect={handleOptionSelect} />
      </div>
      <table className={`chartTable ${styles.overviewChartTable}`}>
        <thead>
          <tr>
            <th className={styles.univColumn} width="25%">Top 20 universities for producing the<br />world's centi-millionaires</th>
            <th
              className={`text-left ${styles.cellHideMobile}  ${styles.sortableColumn} ${sortColumn === 'country' ? styles.selectedColumn : ''}`}
              width="23%"
              onClick={() => handleSort("country")}
            >
              <div className={styles.sortColumnTitle}>
                {(countryCount === 1) ? <IconSort /> : <ReverseIconSort />}
                <span className={styles.sortColumnTitleText}>Country</span>
              </div>
            </th>

            <th
              className={
                `text-right 
                              ${styles.cellHideMobile}
                              ${styles.sortableColumn} 
                              ${sortColumn === 'centiMillionaires' ? styles.selectedColumn : ''}
                              ${sortColumn === 'centiMillionaires' ? styles.displayColumnTitleDiv : ''}
              `}
              width="22%"
              onClick={() => handleSort("centiMillionaires")}
            >
              <div className={styles.sortColumnTitle}>
                <span className={styles.sortColumnTitleText}>Centi-millionaires</span>
                {(centiMilCount === 1) ? <IconSort /> : <ReverseIconSort />}
              </div>
            </th>
            <th
              className={
                `text-right 
                              ${styles.cellHideMobile}
                              ${styles.sortableColumn} 
                              ${sortColumn === 'centiGrowth' ? styles.selectedColumn : ''}
                              ${sortColumn === 'centiGrowth' ? styles.displayColumnTitleDiv : ''}
              `}
              onClick={() => handleSort("centiGrowth")}
            >
              <div className={styles.sortColumnTitle}>
                <span className={styles.sortColumnTitleText}>% of world's centi-<br />millionaires</span>
                {(centiGrowthCount === 1) ? <IconSort /> : <ReverseIconSort />}
              </div>
            </th>
          
          </tr>
        </thead>
        <tbody>
          {sortedData.map((item, index) => (
            <Fragment key={index}>
              <tr className={`${styles.contentRow} ${styles.openedRow}`}>
                <td>{item.university}</td>
                <td className={`text-left 
                                ${styles.cellHideMobile} 
                                ${styles.sortableColumn} 
                                ${sortColumn === 'country' ? styles.selectedColumn : ''}
                              `}>
                  <CountryFlag country={item.country} />
                </td>

                <td rowSpan={2} className={`text-right 
                                            ${styles.hiddenTableRow} 
                                            ${styles.sortableColumn} 
                                            ${styles.combinateRowCells} 
                                            ${sortColumn ? styles.selectedColumn : ''} 
                                            ${sortColumn === 'centiGrowth' ? styles.percentColumn : ''}
                                          `}>
                  {/* {sortColumn === "centiGrowth" ?
                    <ProgressBar
                      percentValue={item.centiGrowth > 0 ? item.centiGrowth : 0}
                      labelText={formatNumberWithDot(item.centiGrowth) + "%"}
                    />
                    : formatNumberWithDot(item[sortColumn])
                  } */}
                  {sortColumn === "centiGrowth" ?
                    formatNumberWithDot(item.centiGrowth) + "%"
                    : formatNumberWithDot(item[sortColumn])
                  }
                </td>
                
                <td className={`text-right 
                                ${styles.cellHideMobile} 
                                ${styles.sortableColumn} 
                                ${styles.cellOnMobile} 
                                ${sortColumn === 'centiMillionaires' ? styles.selectedColumn : ''}
                              `}>
                  {formatNumberWithDot(item.centiMillionaires)}
                </td>
                <td className={`text-right 
                                ${styles.cellHideMobile} 
                                ${styles.sortableColumn} 
                                ${styles.cellOnMobile} 
                                ${sortColumn === 'centiGrowth' ? styles.percentColumn : ''}
                                ${sortColumn === 'centiGrowth' ? styles.selectedColumn : ''}
                              `}>
                  {/* <ProgressBar
                    percentValue={item.centiGrowth > 0 ? item.centiGrowth : 0}
                    labelText={formatNumberWithDot(item.centiGrowth) + "%"}
                  /> */}
                  
                  {formatNumberWithDot(item.centiGrowth) + "%"}
                </td>

              </tr>
              {/* {index === display && ( */}
              <tr className={`${styles.hiddenTableRow}`}>
                <td className={`${styles.countryMobileDiv}`}>
                  <CountryFlag country={item.country} />
                </td>
              </tr>
              {/* )} */}

            </Fragment>
          ))}
          
          

            {/* <tr>
              <td className={`${styles.bufferBeforeTotal}`}></td>
              <td className={`${styles.cellHideMobile} 
                              ${styles.bufferBeforeTotal}`} 
                            ></td>
              <td className={`${styles.cellHideMobile} 
                              ${styles.bufferBeforeTotal}`} 
                            ></td>
              <td className={`${styles.bufferBeforeTotal}`}  ></td>
            </tr>
          
          {univTotalData.map((item) => (
            <Fragment key='data-world-total'>
              <tr 
                className={`${styles.contentRow} `}
              >
                <td><b>{item.city} </b></td>
                <td className={`text-left ${styles.cellHideMobile} ${styles.sortableColumn} ${sortColumn === 'country' ? styles.selectedColumn : ''}`}></td>

                <td rowSpan={2} className={`text-right 
                                            ${styles.hiddenTableRow} 
                                            ${styles.sortableColumn} 
                                            ${styles.combinateRowCells} 
                                            ${sortColumn ? styles.selectedColumn : ''} 
                                            ${sortColumn === 'centiGrowth' ? styles.percentColumn : ''}
                                          `}
                >
                  <b>
                    {sortColumn === "centiGrowth" ?
                      <ProgressBar
                        percentValue={item.centiGrowth > 0 ? item.centiGrowth : 0}
                        labelText={formatNumberWithDot(item.centiGrowth) + "%"}
                      />
                      : formatNumberWithDot(item[sortColumn])
                    }
                    {sortColumn === "centiGrowth" ?
                      formatNumberWithDot(item.centiGrowth) + "%"
                      : formatNumberWithDot(item[sortColumn])
                    }
                  </b>
                </td> 
                
                <td className={`text-right 
                                ${styles.cellHideMobile} 
                                ${styles.sortableColumn} 
                                ${styles.cellOnMobile} 
                                ${sortColumn === 'centiMillionaires' ? styles.selectedColumn : ''}
                              `}
                    style={{padding: "15px 30px"}}
                >
                  <b>{formatNumberWithDot(item.centiMillionaires)}</b>
                </td>
                <td className={`text-right 
                                ${styles.cellHideMobile} 
                                ${styles.sortableColumn} 
                                ${styles.cellOnMobile} 
                                ${sortColumn === 'centiGrowth' ? styles.percentColumn : ''}
                                ${sortColumn === 'centiGrowth' ? styles.selectedColumn : ''}
                              `}
                >
                  <b>
                    <ProgressBar
                      percentValue={item.centiGrowth > 0 ? item.centiGrowth : 0}
                      labelText={formatNumberWithDot(item.centiGrowth) + "%"}
                    />
                    {formatNumberWithDot(item.centiGrowth) + "%"}
                  </b>
                </td>
                    
              </tr>
              
            </Fragment>
          ))}
          <tr></tr> */}

        </tbody>
      </table>

      <div className="footer-note mt-5">
        <ul>
          <li>Figures for June 2023.</li>
        </ul>
        <p>Source: New World Wealth</p>
      </div>
    </>
  )
}

export default Top20Univ;
